import React from 'react';
import { Button } from '@/components/ui/button';

/* A fronteira de erro da raiz do app (PROMPT 155).
 *
 * Sem ela, qualquer erro de render (um objeto mostrado como texto, por exemplo)
 * desmontava a árvore inteira do React e a tela ficava em branco, sem nenhuma
 * pista para quem usa. Agora aparece uma mensagem em português com "Recarregar".
 *
 * O registro no console leva só o tipo do erro, a mensagem e a pilha de
 * componentes: nada do estado da tela nem dado de cliente. */
export class FronteiraDeErro extends React.Component {
  constructor(props) {
    super(props);
    this.state = { quebrou: false };
  }

  static getDerivedStateFromError() {
    return { quebrou: true };
  }

  componentDidCatch(erro, info) {
    // eslint-disable-next-line no-console
    console.error('[fronteira-de-erro]', erro?.name, erro?.message, info?.componentStack);
  }

  render() {
    if (!this.state.quebrou) return this.props.children;
    return (
      <div
        role="alert"
        className="min-h-screen flex items-center justify-center bg-background text-foreground p-6"
        data-testid="fronteira-de-erro"
      >
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-xl font-semibold">Algo deu errado nesta tela</h1>
          <p className="text-sm text-muted-foreground">
            Recarregue a página para continuar. Se o erro voltar, avise o suporte.
          </p>
          <Button onClick={() => window.location.reload()} data-testid="fronteira-recarregar">
            Recarregar
          </Button>
        </div>
      </div>
    );
  }
}

export default FronteiraDeErro;
